export const isValidProductId = (productId) => {
  if (productId == null) return false;
  const id = String(productId).trim();
  return id.length > 0 && id !== 'undefined' && id !== 'null';
};

export const resolveProductId = (entity) =>
  entity?.productId || entity?.product_id || entity?.id || entity?._id || '';
